export const KEY_ACTIVE_CUSTOMER = 'active-customer'
